import { render, staticRenderFns } from "./GroupMemberItem.vue?vue&type=template&id=96aa338e"
import script from "./GroupMemberItem.vue?vue&type=script&lang=js"
export * from "./GroupMemberItem.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberItem.vue?vue&type=style&index=0&id=96aa338e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports